export default __webpack_public_path__ + "static/media/973.549baf5f.png";